import logo from './logo.svg';
import './App.css';
import toast, { Toaster } from 'react-hot-toast';
import 'bootstrap/dist/css/bootstrap.min.css';

import { createContext, useEffect, useState } from 'react';

import { Route, Routes } from 'react-router-dom';
import Home from './Component/Home';
import ProjectDetail from './Component/Projects/ProjectDetail';
import Header from './Component/Header/Header';
import Footer from './Component/Footer/Footer';
import Blogs from './Component/Blogs/Blogs';
import NoPageFound from './Component/NoPageFound';

function App() {


  return (

    <>

      <Header></Header>
      <Routes>
        <Route path='/' element={<Home></Home>}></Route>
        <Route path='/project/:id' element={<ProjectDetail></ProjectDetail>}></Route>
        <Route path='/blogs' element={<Blogs></Blogs>}></Route>
        <Route path='*' element={<NoPageFound></NoPageFound>}></Route>
      </Routes>

      <Footer></Footer>

      <Toaster />

    </>

  );
}

export default App;
